import styled from 'styled-components';

export const OptionStyled = styled('option')`
    color: #0a3b5b;
    font-size: 13px;
`;
